module.exports = __webpack_public_path__ + "img/VG.c473db2c.png";